import { Box, CircularProgress, Stack, Typography } from "@mui/material"
import { Else } from "lib/@components/else"
import { If } from "lib/@components/switch"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { MacroExpander } from "authoring/routes/macro/components/macro-expander"
import { DATE_FORMATS } from "lib/@constants/date-format"
import { useUser } from "lib/user/use-user"
import { UserAvatar } from "minimals-template/components/user-avatar"
import { useEffect, useState } from "react"
import { getAuditsByReferenceIdAndType } from "routes/audit/controller/get-audits-by-reference-id"
import { PAYLOAD_STATUS_DRAFT_CREATED } from "routes/audit/lib/audit-constants.mjs"
import { AutoToggleAccordion } from "lib/@components/auto-toggle-accordion"
import { TruncatedTypography } from "lib/@components/truncated-typography"

export function DraftJustification() {
    const { target, draftReason } = useBoundContext()

    const { data, loading } = getAuditsByReferenceIdAndType.useResults.status(target.id, "customSchedule", {
        "payload.status": PAYLOAD_STATUS_DRAFT_CREATED,
        "payload.groupReviewId": target.groupReviewId,
    })
    const [audits, setAudits] = useState([])
    const audit = audits[0]
    const auditReason = draftReason && !audit?.payload?.reason ? draftReason : audit?.payload?.reason
    const { user } = useUser(audit?.userId)
    useEffect(
        function () {
            if (data && data !== audits) {
                setAudits(data)
            }
        },
        [data, audits]
    )

    const summary = <Typography variant={"subtitle1"}>Submitted Audit Explanation</Typography>
    const details = (
        <If truthy={loading && !draftReason}>
            <Box sx={{ display: "flex", justifyContent: "center", py: 2, backgroundColor: "grey.200" }}>
                <CircularProgress size={36} color="primary" />
            </Box>
            <Else>
                <Stack
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    sx={{ backgroundColor: "grey.200", px: 2 }}
                    data-cy="draft-justification-user"
                >
                    <UserAvatar sx={{ width: 32, height: 32 }} user={user} />
                    <TruncatedTypography>{user?.displayName}</TruncatedTypography>
                    <Box flex={1} />
                    <Typography data-cy="draft-justification-date" variant={"caption"} sx={{ color: "text.secondary" }}>
                        {Date.create(audit?.date).format(DATE_FORMATS.dateAndTime)}
                    </Typography>
                </Stack>
                <MacroExpander>
                    <Box sx={{ backgroundColor: "grey.200", p: 2 }} data-cy="draft-justification-content">
                        <Typography
                            sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                            dangerouslySetInnerHTML={{ __html: auditReason }}
                        />
                    </Box>
                </MacroExpander>
            </Else>
        </If>
    )

    return <AutoToggleAccordion summaryContent={summary} detailsContent={details} />
}
